import { CheckmarkIcon, CloseIconWithCircle, Spinner, TimerIcon } from '@va/icons';
import { CustomDomainProvisioningStatus } from '@va/shared/api/custom-domains';
import { Paragraph, paragraphSizes } from '@va/ui/design-system';
import classNames from 'classnames';

export type ProvisioningStep = {
  value: string;
  label: string;
};

export type ProvisioningStepsParams = {
  status: string;
  steps: ProvisioningStep[];
  currentStepVal: string;
};

export const ProvisioningSteps = ({ status, steps, currentStepVal }: ProvisioningStepsParams) => {
  return (
    <ul>
      {steps.map((step, idx) => {
        const currentStepIndex = steps.findIndex((item) => item.value === currentStepVal);
        const isCompleted = function () {
          if (idx < currentStepIndex) return true;
          return idx === currentStepIndex && status === CustomDomainProvisioningStatus.active;
        };
        const isCurrent = function () {
          return idx === currentStepIndex && status === CustomDomainProvisioningStatus.pending;
        };

        const isPending = function () {
          return idx > currentStepIndex;
        };

        const isFailed = function () {
          return (
            idx === currentStepIndex &&
            [CustomDomainProvisioningStatus.cancelled, CustomDomainProvisioningStatus.failed].includes(
              status as CustomDomainProvisioningStatus,
            )
          );
        };

        return (
          <li className={classNames('py-1 px-2 flex gap-2 items-center', {})}>
            {isCompleted() && <CheckmarkIcon className='w-3 h-3' />}
            {isCurrent() && <Spinner className='w-3 h-3' />}
            {isPending() && <TimerIcon color='#999999' className='w-3 h-3' />}
            {isFailed() && <CloseIconWithCircle color='red' className='w-3 h-3' />}

            <Paragraph
              colorClassName={classNames({ 'text-gray-dusty': isPending(), 'text-negative': isFailed() })}
              size={paragraphSizes.tiny}
            >
              {step.label}
            </Paragraph>
          </li>
        );
      })}
    </ul>
  );
};
